module.exports = __webpack_public_path__ + "static/img/case.513754e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case.png
// module id = O7x/
// module chunks = 1